declare namespace $ {

	export class $shm_hitalama_dragtree_item extends $shm_hitalama_draglist_item {
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map